import React, { type ReactElement, memo } from 'react';
import Content from 'reactApp/ui/Content/Content';
import { Dialog } from 'reactApp/ui/Dialog/Dialog';

import { SelectAlbumPopupContent } from './components/Content/SelectAlbumPopupContent';
import styles from './SelectAlbumPopup.css';
import type { IProps } from './SelectAlbumPopup.types';

export const SelectAlbumPopup = memo(function SelectAlbumPopup(props: IProps): ReactElement {
    const { onClose, title } = props;

    return (
        <Dialog open id="select-album" onCancel={onClose} className={styles.modal}>
            <Content isModal qaId="select-album-content">
                <div className={styles.root}>
                    <div className={styles.title} data-qa-id="title">
                        {title}
                    </div>

                    <SelectAlbumPopupContent {...props} />
                </div>
            </Content>
        </Dialog>
    );
});
